var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusButtonDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "#1C1C1C",
    stroke: "#3D7AB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.24 27.24H32.76V17.76C32.76 16.2375 31.5263 15 30 15C28.4775 15 27.24 16.2338 27.24 17.76V27.24H17.76C16.2338 27.24 15 28.4775 15 30C15 31.5225 16.2338 32.76 17.76 32.76H27.24V42.24C27.24 43.7625 28.4738 45 30 45C31.5225 45 32.76 43.7663 32.76 42.24V32.76H42.24C43.7625 32.76 45 31.5263 45 30C45 28.4775 43.7663 27.24 42.24 27.24Z",
    fill: "#3D7AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButtonDark);
export default __webpack_public_path__ + "static/media/plusButtonDark.2383866dd1a90e169de4172200a2d5a7.svg";
export { ForwardRef as ReactComponent };